<template>
    <div class="LayoutFull">
        <component :is="header"></component>
        <component :is="sidebar"></component>
        <div class="LayoutFull-mainContainer" v-bind:class="{ 'is-close': closeSidebar }">
            <b-breadcrumb class="LayoutFull-Breadcrumb" :items="breadcrumb"></b-breadcrumb>
                <router-view :key="$route.fullPath"/>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import InterModal from "../../components/modal/InterModal";
    import FormUpdatePassword from "./FormUpdatePassword";

    const HeaderComponent = () => import('@/components/header/Header');
    const SidebarComponent = () => import('@/components/sidebar/Sidebar');

    export default {
        components: {
            FormUpdatePassword,
            InterModal,
            HeaderComponent,
            SidebarComponent
        },
        name: "LayoutFull",

        data() {
            return {

            }
        },

        computed: {

            ...mapGetters([
                'closeSidebar',
                'breadcrumb',
            ]),

            header() {
                return HeaderComponent;
            },

            sidebar() {
                return SidebarComponent;
            },
        },
        mounted() {

        },
        methods: {

        }
    }
</script>

<style scoped>

</style>
